import client from 'shared/graphql/client'
import {
    GetCandidateDocumentsForDownload,
    GetDocumentDownloadUrl,
} from '../../../graphql/download.gql'
import { Downloader } from './types'

export const fetchResume: Downloader = async (candidateId) => {
    const { data: candidateData } = await client.query({
        query: GetCandidateDocumentsForDownload,
        variables: { candidateId },
        fetchPolicy: 'network-only',
    })

    const resume = candidateData?.candidate?.documents?.find(
        (d) => d.documentType === 'Resume'
    )
    if (!resume) {
        throw new Error('No resume found for this candidate')
    }

    const { data: urlData } = await client.query({
        query: GetDocumentDownloadUrl,
        variables: { documentId: resume.id, forceDownload: true },
        fetchPolicy: 'network-only',
    })

    if (!urlData?.download?.url) {
        throw new Error('Could not generate download URL')
    }

    return {
        url: urlData.download.url,
        filename: resume.documentKey || 'resume.pdf',
    }
}
